import {
	FieldValues,
	FieldPath,
	UseControllerProps,
	useController,
} from 'react-hook-form';
import {
	IconButton,
	InputAdornment,
	FilledInput,
	FormControl,
} from '@mui/material';
import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

interface AppSummarySearchBarProps {
	placeholder?: string;
	autoMinWidth?: boolean;
	onchange?: (value: string) => void;
}

export default function AppSummarySearchBar<
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
	placeholder,
	onchange,
	...props
}: AppSummarySearchBarProps & UseControllerProps<TFieldValues, TName>) {
	const { field } = useController(props);
	const searchKey = field.value;
	const searchKeyOnChange = field.onChange;

	const [text, setText] = useState<string>(field.value);

	useEffect(() => {
		setText(searchKey);
	}, [searchKey]);

	const clearButtonOnClick = () => {
		setText('');
		searchKeyOnChange(undefined);
		onchange ? onchange('') : searchKeyOnChange(undefined);
	};

	const searchButtonOnClick = () => {
		searchKeyOnChange(text);
		onchange ? onchange(text) : searchKeyOnChange(text);
	};
	return (
		<>
			<FormControl
				sx={{
					width: '100%',
					paddingTop: 0,
				}}
				variant='filled'
			>
				{/* <InputLabel>{placeholder}</InputLabel> */}
				<FilledInput
					sx={{
						'& .MuiFilledInput-input': {
							paddingTop: '9px',
							height: '35px',
						},
						'& .MuiInputAdornment-positionStart': {
							marginTop: '3px!important',
						},
					}}
					onChange={(e) => {
						setText(e.target.value);
					}}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							searchButtonOnClick();
						}
					}}
					value={text ?? ''}
					size='small'
					placeholder={placeholder}
					type={'text'}
					startAdornment={
						<InputAdornment position='start'>
							<SearchIcon />
						</InputAdornment>
					}
					endAdornment={
						<InputAdornment position='end'>
							{searchKey && (
								<IconButton type='button' onClick={clearButtonOnClick}>
									<CloseIcon />
								</IconButton>
							)}
						</InputAdornment>
					}
				/>
			</FormControl>
		</>
	);
}
